"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Steps = void 0;
const react_1 = __importDefault(require("react"));
const Icon_1 = require("../Icon");
const Step_1 = require("./Step/Step");
require("./index.scss");
const Steps = (props) => {
    const { items, handleClick } = props;
    const onClick = (i) => {
        if (handleClick && items[i].state === null)
            handleClick(i);
    };
    return (react_1.default.createElement("div", { className: 'steps' }, items.map((item, index) => (react_1.default.createElement("div", { className: `steps__item ${item.state === 'active' ? 'steps__item--active' : ''}`, key: index },
        react_1.default.createElement(Step_1.Step, { handleClick: item.state === null ? () => onClick(index) : null, key: index, state: item.state, first: index === 0 },
            item.iconName && (react_1.default.createElement("span", { className: 'step__icon' },
                react_1.default.createElement(Icon_1.Icon, { name: item.iconName }))),
            item.text && (react_1.default.createElement("span", { className: 'step__text' }, item.text))))))));
};
exports.Steps = Steps;
//# sourceMappingURL=index.js.map